import { request, download } from './request'

//*******登录********
//获取短信验证码
export const GetSmSCode = params => request.get('/sms/index', {params});
//短信验证码登录
export const Login_SmSCode = params => request.post('/entrance/mobile/login', params);
//账密登录
export const Login_Account = params => request.post('/account/login', params);
//重置密码
export const Reset_Password = params => request.post('/account/resetPassword', params);
//手机注册
export const Register_Mobile = params => request.post('/entrance/mobile/reg', params);
//登出
export const Logout = params => request.get('/account/logout', {params});
//获取微信扫码结果
export const Wechat_GetResult = params => request.get('/entrance/wechat/scan_result', {params});
//绑定微信手机
export const Wechat_BindMobile = params => request.post('/entrance/wechat/bind_mobile', params);

//*******我的服务********
//当前订阅
export const VatCentre_Service_GetCurrentSub = params => request.get('/order/current_sub', {params});
//获取基本信息
export const VatCentre_Service_GetBasicInfo = params => request.get('/account/info', {params});
//修改基本信息
export const VatCentre_Service_UpdateBasicInfo = params => request.post('/account/update', params);
//修改密码
export const VatCentre_Service_ChangePassword = params => request.post('/account/resetPassword', params);
//发票列表
export const VatCentre_Service_GetInvoiceList = params => request.get('/invoice_title/list', {params});
//新增发票
export const VatCentre_Service_AddInvoice = params => request.post('/invoice_title/save', params);
//编辑列表
export const VatCentre_Service_UpdateInvoice = params => request.post('/invoice_title/update', params);
//设为默认
export const VatCentre_Service_SetInvoiceDefault = params => request.get('/invoice_title/set_default', {params});
//删除发票
export const VatCentre_Service_DelInvoice = params => request.get('/invoice_title/del', {params});

//*******支付面板********
//全部服务信息
export const VatCentre_Service_GetAllServices = params => request.get('/service/list', {params});
//创建订单
export const VatCentre_Service_CreateOrder = params => request.post('/order/create', params);
//获取订单支付结果
export const VatCentre_Service_GetPayResult = params => request.get('/order/pay_result', {params});

//*******我的申报********
//获取申报列表
export const VatCentre_Declare_GetList = params => request.get('/archive/list', {params});
//获取授权链接
export const VatCentre_Declare_AuthUrl = params => request.get('/archive/auth_url', {params});
//授权回调
export const VatCentre_Declare_AuthRedirect = params => request.get('/archive/auth_redirect', {params});
//添加税号
export const VatCentre_Declare_AddVRN = params => request.post('/archive/create', params);
//解析店铺链接
export const VatCentre_Declare_ShopUrlParse = params => request.get('/archive/shop_url_parse', {params});
//检测vat税号
export const VatCentre_Declare_CheckVatNumber = params => request.get('/archive/check_vat_number', {params});
//同步税期
export const VatCentre_Declare_PullPeriod = params => request.get('/archive/pull_period', {params});
//计税工具递交申报
export const VatCentre_Declare_DeclareWithTool = params => request.post('/archive/calculation_tax', params, {timeout: 180000});
//计税工具确认税金
export const VatCentre_Declare_DeclareConfirm = params => request.post('/archive/calculation_tax_confirm', params);
//填税金方式递交申报
export const VatCentre_Declare_DeclareWithBox = params => request.post('/archive/declare_tax', params);
//下载回执
export const VatCentre_Declare_DownReceipt = params => download.get('/archive/download_tax_bill', {params});
//缴税记录
export const VatCentre_Declare_GetPayTaxList = params => request.get('/archive/tax_pay_list', {params});

//*******税金试算********
//列表
export const VatCentre_Calculate_GetList = params => request.get('/trial/list', {params});
//开始计算
export const VatCentre_Calculate_Calculation = params => request.post('/trial/calculation', params, {timeout: 180000});
//添加税期
export const VatCentre_Calculate_BindPeriod = params => request.post('/trial/bind_period', params);
//导入申报 -- 税金试算
export const VatCentre_Calculate_ImportDeclare = params => request.post('/trial/import_declare', params);
//试算结果 -- 列表
export const VatCentre_Calculate_DeclareResult = params => request.post('/trial/view_result', params);
//删除
export const VatCentre_Calculate_Del = params => request.get('/trial/del', {params});

//*******欠税监控********
//列表
export const VatCentre_Monitor_List = params => request.get('/monitor/list', {params});
//同步更新
export const VatCentre_Monitor_SyncRefresh = params => request.get('/monitor/sync_latest', {params});



//文件上传接口
export const FileUpload = params => request.post('/upload/file', params, {timeout: 180000});



// WEBPACK FOOTER //
// ./src/api/index.js